import { useEffect } from "react";
import { Link } from "react-router-dom";
import { VALUES } from "../data/about";
import useSeo from "../seo/useSeo";
import { ROUTE_META } from "../seo/seoConfig";

// image
import aboutImage from "../assets/about_image.JPG";

const AboutPage = () => {
  useSeo({
    title: ROUTE_META["/about"].title,
    description: ROUTE_META["/about"].description,
    canonicalPath: "/about",
  });

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, []);

  return (
    <div className="about-page">
      {/* Hero */}
      <div className="about-hero">
        <div className="about-hero-inner">
          <div className="section-label">Our Story</div>
          <h1 className="about-hero-title">
            A Decade of <em>Trusted</em> Timekeeping
          </h1>
          <div className="section-line" />
          <p className="about-hero-subtitle">
            Legacy Timepiece is a Jakarta boutique built on a simple idea — that
            buying a luxury watch should feel as considered as wearing one.
          </p>
        </div>
      </div>

      {/* Intro / Story */}
      <section className="about-story">
        <div className="about-story-inner">
          <div className="about-story-img">
            <img
              src={aboutImage}
              alt="Legacy Timepiece boutique interior"
            />
          </div>
          <div className="about-story-text">
            <div className="section-label">Established 2015</div>
            <h2 className="about-story-title">
              Founded by collectors, for collectors.
            </h2>
            <div className="detail-divider" />
            <p className="about-story-desc">
              Established in 2015, Legacy Timepieces draws on over 40 years of
              experience by the founders. We are a family-owned business
              spanning three generations, and as such are able to offer a unique
              blend of professional aptitude and real personal connection. At
              Legacy, we respect the serious deliberation and care that comes
              with the buying and selling of luxury items, while at the same
              time valuing you as a guest into our family's home away from home.
            </p>
            <p className="about-story-desc">
              Fairness and honesty are at the heart of our work at Legacy
              Timepieces. Using the latest market information as a guide, we
              strive to give our customers the best market prices with full
              transparency. These deeply-held values drive our every day work at
              our store. Our customers can rest assured knowing that our family
              at Legacy Timepieces works tirelessly to give you the best deal.
            </p>
          </div>
        </div>
      </section>

      {/* Values */}
      <section className="about-values">
        <div className="section-header">
          <div className="section-label">What We Stand For</div>
          <h2 className="section-title">Our Values</h2>
          <div className="section-line" />
        </div>
        <div className="about-values-grid">
          {VALUES.map((v, i) => (
            <div className="about-value-card" key={i}>
              <div className="about-value-num">
                {String(i + 1).padStart(2, "0")}
              </div>
              <div className="about-value-label">{v.label}</div>
              <h3 className="about-value-title">{v.title}</h3>
              <p className="about-value-desc">{v.desc}</p>
            </div>
          ))}
        </div>
      </section>

      {/* CTA */}
      <section className="about-cta">
        <div className="about-cta-inner">
          <div className="section-label">Visit the Boutique</div>
          <h2 className="about-cta-title">
            Come see the collection in person.
          </h2>
          <p className="about-cta-text">
            We welcome walk-ins, but private appointments allow our team to
            prepare specific references in advance and give you the unhurried
            attention a considered purchase deserves.
          </p>
          <div className="about-cta-actions">
            <Link to="/watches" className="about-cta-btn about-cta-btn-primary">
              Browse the Collection
            </Link>
            <a
              href="https://wa.me/6285178228989"
              target="_blank"
              rel="noopener noreferrer"
              className="about-cta-btn about-cta-btn-secondary"
            >
              Book an Appointment
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default AboutPage;
